<template>
	<div>
		<h1>Profile <b-button class="btn btn-warning" v-b-modal.ProfileEditWidget >Edit</b-button></h1>		
		<div>
			<table class="table" v-if="loaded">
				<tr><td>Name</td><td>{{user.name}}</td></tr>
				<tr><td>Username</td><td>@{{user.username}}</td></tr>
				<tr v-if="user.email"><td>Email</td><td>{{user.email}}</td></tr>
				<tr v-if="user.about"><td>About</td><td>{{user.about}}</td></tr>
				<tr><td>Joined at</td><td>{{ new Date(user.created) | moment("dddd, MMMM Do YYYY") }}</td></tr>
			</table>
		</div>
		<b-modal id="ProfileEditWidget" title="Edit profile" okTitle="Update">
			<ProfileEditWidget :user="user" :API="$API"></ProfileEditWidget>
		</b-modal>
	</div>
</template>
<script>
	import ProfileEditWidget from './ProfileEditWidget.vue'
	export default {
		name: 'ProfilePage',
		data(){
			return {
				loaded:false,
				user:{}
			}
		},
		components:{
			ProfileEditWidget
		},
		mounted(){
			if(!this.$API.loggedIn){
				this.$router.push("/login?redirect=" + this.$route.path)
				return;
			}
			this.loadProfile();
		},
		methods:{
			show(){
				this.loaded=true;
				this.$API.title="Profile | " + this.user.name;
			},
			loadProfile(){
				if("id" in this.$route.params){
					this.$API.title="Loading Profile...";
					this.$API.loadProfile(this.$route.params.id).then((response)=>{
						if(response.status=="fail"){
				  			this.$router.push("/404");
				  			return;
				  		}
						this.user=response.profile;
						this.show();
					});
				}
				else{
					if(!Object.keys(this.$API.user).length){
						this.$API.title="Loading Profile...";
						this.$API.loadProfile().then((response)=>{
							this.user=response.profile;
							this.show();
						});
					}
					else
					{
						this.user=this.$API.user;
						this.show();
					}
				}
			}
		},
		watch: {
			'$route' (to, from) {
				this.loaded=false;
				this.loadProfile();
			}
		}
	}
</script>